import { render, staticRenderFns } from "./ClientsContractModal.vue?vue&type=template&id=096d2e53&scoped=true&"
import script from "./ClientsContractModal.vue?vue&type=script&lang=js&"
export * from "./ClientsContractModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientsContractModal.vue?vue&type=style&index=0&id=096d2e53&prod&scoped=true&lang=css&"
import style1 from "./ClientsContractModal.vue?vue&type=style&index=1&id=096d2e53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d2e53",
  null
  
)

export default component.exports